export default __webpack_public_path__ + "static/media/picThiAnhDao.6d9e0b3e.png";